@if (cancellation(); as cancellation) {
  <div class="order-cancelled-notice" role="alert">
    <i class="pi pi-times-circle order-cancelled-notice__icon"></i>
    <div class="order-cancelled-notice__body">
      <p class="order-cancelled-notice__title">
        Order{{ cancellation.orderNumber ? ' ' + cancellation.orderNumber : '' }} cancelled
      </p>
      <p class="order-cancelled-notice__reason">{{ cancellation.reason ?? fallbackReason }}</p>
    </div>
    <button
      type="button"
      class="order-cancelled-notice__close"
      (click)="dismiss()"
      aria-label="Dismiss cancellation notice"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>
}
